import React from 'react'
import { Select, Space } from 'antd';
import styled from 'styled-components';
// import { IconImg } from '../../StyledComponents/Header';
// import { UserOutlined } from '@ant-design/icons';

const { Option } = Select;

function QuerySelectItem(props) {
  return (
    <SpaceItem wrap className={props.main_class} >
        {props.is_icon? <SelectIcon>₹</SelectIcon> : null}
        <ItemSelect
            is_icon={props.is_icon}
            size={props.size ? props.size : "large"}
            placeholder={props.placeholder ?props.placeholder : "Select"}
            style={{
                width: props.width? props.width : 230,
            }}
            onChange={(e) => props.handleChange(e,props.name)}
            // options={props.options}
            value={props.value}
            pdg={props.pdg}
            height={props.height}
            disabled={props.disabled? props.disabled : false}
        >
            {props.options?.map((i)=> 
                props.name === 'origin_charge' ? 
                <Option value={i.originName}>{i.originName}</Option> : 
                <Option value={i.destinationName}>{i.destinationName}</Option>
            )}
        </ItemSelect>
        
       
    </SpaceItem>
  )
}

export default QuerySelectItem

const SpaceItem = styled(Space)`
    position: relative;
    &.main_class {
        width: 57%;
    }
`
const SelectIcon = styled.span`
    z-index: 9;
    position: absolute;
    top: 10px;
    left: 17px;
    color: #242424 !important;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Roboto';
    font-style: normal;
`
const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: 6px !important;
        padding: ${({ pdg }) => pdg? pdg : "unset"};
        padding-left: ${({ is_icon })=> is_icon ? "20px !important": 'unset'};
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        height: ${({ height }) => height? height : 'unset'};
        :hover,:focus,:not(:focus) {
            border-color: #d9d9d9 !important;
            box-shadow: none !important;
        }
    }
    & .ant-select-selection-placeholder {
        color: #B5B5C3 !important;
        font-size: 13px;
        font-weight: 500;
        font-family: 'Roboto';
        font-style: normal;
    }
    & .ant-select-arrow {
        color: #242424 !important;
    }
    & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    }
    
`